import "bootstrap/dist/css/bootstrap.css";
import "./App.scss";
import React, { Suspense } from 'react'
import routes from './routes'
import { useNavigate, useLocation, Routes, Route, } from "react-router-dom";

const App = (props) => {
  const navigation = useNavigate();
  const location = useLocation();

  return (
    <React.Fragment>
      <Suspense fallback={'Loading...'}>
        <div>
          <Routes>
            {
              routes.map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    element={
                      <route.layout {...props} title={route.title}>
                        <route.component {...props} navigation={navigation} location={location} />
                      </route.layout>
                    }
                  />
                )
              })
            }
          </Routes>
        </div>
      </Suspense>
    </React.Fragment>
  )
}

export default App;